import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { EmpresaProvider } from './contexts/EmpresaContext';
import Layout         from './components/layout/Layout';
import LoginPage      from './pages/LoginPage';
import DashboardPage  from './pages/DashboardPage';
import DocumentosPage from './pages/DocumentosPage';
import EmpresasPage   from './pages/EmpresasPage';
import UsuariosPage   from './pages/UsuariosPage';
import ApiKeysPage    from './pages/ApiKeysPage';
import AuditoriaPage  from './pages/AuditoriaPage';
import PerfilPage          from './pages/PerfilPage';
import ConfiguracoesPage  from './pages/ConfiguracoesPage';
import MinhaEmpresaPage   from './pages/MinhaEmpresaPage';
import ImportacaoPage     from './pages/ImportacaoPage';

function RotaProtegida({ children, perfis }) {
  const { usuario, carregando } = useAuth();

  if (carregando) {
    return (
      <div className="flex items-center justify-center h-screen bg-surface">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-slate-400 text-sm">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!usuario) return <Navigate to="/login" replace />;
  if (perfis && !perfis.includes(usuario.perfil)) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<RotaProtegida><Layout /></RotaProtegida>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard"  element={<DashboardPage />} />
        <Route path="documentos" element={<DocumentosPage />} />
        <Route path="empresas"   element={<EmpresasPage />} />
        <Route path="usuarios"   element={<RotaProtegida perfis={['admin']}><UsuariosPage /></RotaProtegida>} />
        <Route path="api-keys"   element={<RotaProtegida perfis={['admin']}><ApiKeysPage /></RotaProtegida>} />
        <Route path="auditoria"     element={<RotaProtegida perfis={['admin', 'contador']}><AuditoriaPage /></RotaProtegida>} />
        <Route path="configuracoes"  element={<RotaProtegida perfis={['admin']}><ConfiguracoesPage /></RotaProtegida>} />
        <Route path="minha-empresa"  element={<RotaProtegida perfis={['cliente', 'contador']}><MinhaEmpresaPage /></RotaProtegida>} />
        <Route path="importacao"     element={<ImportacaoPage />} />
        <Route path="perfil"         element={<PerfilPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <EmpresaProvider>
          <AppRoutes />
        </EmpresaProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#1e293b',
              color: '#f1f5f9',
              border: '1px solid #334155',
              borderRadius: '10px',
            },
            success: { iconTheme: { primary: '#10b981', secondary: '#0f172a' } },
            error:   { iconTheme: { primary: '#ef4444', secondary: '#0f172a' } },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
